import React from 'react'
import PropTypes from 'prop-types'
import { ListCard } from '~/components/ListCard'
import { track } from '~/utils'
import {
  EXPLORE_FEED_ITEM_TAPPED,
  EXPLORE_FEED_ITEM_VIEWED,
  EXPLORE_FEED_SEE_ALL_CLICKED,
} from '~/lib/tracking-events'
import ViewportTracking from '~/components/ViewportTracking'
import { decodeGlobalId } from '~/utils/id'
import { thumbnailEventCollectionPropTypes } from '~/graphql/fragments/thumbnailEventCollection'

const EventCollectionCard = ({ t, eventCollection, itemOrder }) => {
  const { id, status, title, subtitle, group } = eventCollection
  const employeeOnly = status === 'PREVIEW'
  const { items = {}, imageThumbnailUrl, imageBackgroundUrl, logoUrl } = group
  const { edges: groupItems = [] } = items

  const trackClick = eventId => {
    track(EXPLORE_FEED_ITEM_TAPPED, {
      itemId: decodeGlobalId(id),
      eventId,
      itemOrder,
      itemType: eventCollection.type,
      title,
    })
  }

  const trackSeeAll = () => {
    track(EXPLORE_FEED_SEE_ALL_CLICKED, {
      itemId: decodeGlobalId(id),
      itemOrder,
      itemType: eventCollection.type,
      title,
    })
  }

  return (
    <ViewportTracking
      event={EXPLORE_FEED_ITEM_VIEWED}
      payload={{
        itemId: decodeGlobalId(id),
        itemOrder,
        itemType: eventCollection.type,
        title,
      }}
    >
      <ListCard
        t={t}
        title={title}
        text={subtitle}
        variant={imageThumbnailUrl ? 'THUMBNAIL' : 'NO_THUMBNAIL'}
        dialogItems={groupItems}
        imageThumbnailUrl={imageThumbnailUrl}
        imageBackgroundUrl={imageBackgroundUrl}
        logoUrl={logoUrl}
        employeeOnly={employeeOnly}
        trackClick={trackClick}
        trackSeeAll={trackSeeAll}
      />
    </ViewportTracking>
  )
}

EventCollectionCard.propTypes = {
  t: PropTypes.func.isRequired,
  eventCollection: thumbnailEventCollectionPropTypes.isRequired,
  itemOrder: PropTypes.number.isRequired,
}

export default EventCollectionCard
